
type PostRequestOptions = {
    headers?: Record<string, string>;
    body: Record<string, unknown> | FormData;
    signal?: AbortSignal;
};

type GetRequestOptions = {
    headers?: Record<string, string>;
    signal?: AbortSignal;
};

function getApiUrl() {
  // Verificando se está em ambiente de desenvolvimento (localhost ou 127.0.0.1)
  const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const api_url = isDev ? process.env.REACT_APP_API_URL_DEVP : process.env.REACT_APP_API_URL_PROD;
  return api_url;
}

export function getURL() {
  const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const url = isDev ? process.env.REACT_APP_URL_DEVP : process.env.REACT_APP_URL_PROD;
  return url;
}
  
export async function postRequest<T>(url: string, options: PostRequestOptions): Promise<T> {
  const { headers = {}, body, signal } = options;
  const end_point = getApiUrl() + url;

  try {
    const isFormData = body instanceof FormData;
    const requestHeaders: Record<string, string> = {
      // ...(body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...headers,
    };

    const response = await fetch(end_point, {
      method: "POST",
      // headers: requestHeaders,
      // body: body instanceof FormData ? body : JSON.stringify(body),
      headers: isFormData ? headers : requestHeaders, // Não sobrescreva cabeçalhos no caso de FormData
      body: isFormData ? body : JSON.stringify(body), // FormData é usado diretamente como o corpo
      signal,
    });

    if (!response.ok) {
      let errorMessage = `Erro: ${response.status}`;
      try {
        const errorDetails = await response.json();
        errorMessage += ` - ${errorDetails.message || JSON.stringify(errorDetails)}`;
      } catch {
        errorMessage += " - Resposta inválida do servidor";
      }
      throw new Error(errorMessage);
    }

    const data = await response.json();
    return data as T;
  } catch (error) {
    throw new Error(`${(error as Error).message}: Erro ao executar postRequest`);
  }
} 

export async function getRequest<T>(url: string, options: GetRequestOptions = {}): Promise<T> {
  const { headers = {}, signal } = options;
  const end_point = getApiUrl() + url;

  try {
    const response = await fetch(end_point, {
      method: "GET",
      headers,
      signal,
    });

    // Verifica se a resposta foi bem-sucedida
    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(`${response.status} - ${errorDetails.message || "Requisição falhou"}`);
    }

    // Retorna a resposta como JSON com tipagem genérica
    const data = await response.json();
    return data as T;

  } catch (error) {
    throw new Error(`${(error as Error).message}: Erro ao executar getRequest`);
  }
}
